import {primitiveUserSettingCodes} from "@/enums/primitiveUserSettingCodes";

const initState = () => ({
  fields: {},
  adminSettings: {},
  isMenuCollapsed: false,
})

export const state = initState

export const getters = {
  fieldsByModuleCode: (state) => (moduleCode) => state.fields[moduleCode],
  adminSettingByCode: (state) => (moduleCode) =>
    state.adminSettings[moduleCode],
  isMenuCollapsed: (state) => state.isMenuCollapsed,
}

export const mutations = {
  setFields(state, {fields}) {
    state.fields = fields
  },
  setAdminSettings(state, {adminSettings}) {
    state.adminSettings = adminSettings
  },
  setIsMenuCollapsed(state, isOpen) {
    state.isMenuCollapsed = isOpen
  },
  reset(state) {
    Object.assign(state, initState())
  },
}

export const actions = {
  fetchFields({commit}) {
    return this.$axios.$get('/modules/cp/fields').then((fields) => {
      const fieldsObj = {}
      for (const field of fields) {
        fieldsObj[field.moduleCode] = field.fields
      }
      commit('setFields', {fields: fieldsObj})
    })
  },
  fetchAdminSettings({commit}) {
    return this.$axios.$get('/adminSettings').then((adminSettings) => {
      const fieldsObj = {}
      for (const adminSetting of adminSettings) {
        fieldsObj[adminSetting.code] = adminSetting
      }
      commit('setAdminSettings', {adminSettings: fieldsObj})
    })
  },
  fetchAdminSettingByCode({commit}, code) {
    return this.$axios.$get('/admin-settings/cp/settings/' + code)
  },
  fetchIsMenuCollapsed({commit}) {
    return this.$axios.$get('/usersetting/' + primitiveUserSettingCodes.CP_IsMenuCollapsed).then((isOpen) => {
      commit('setIsMenuCollapsed', isOpen)
    })
  },
  saveIsMenuCollapsed({commit}, isOpen) {
    return this.$axios.$post('/usersetting/' + primitiveUserSettingCodes.CP_IsMenuCollapsed, isOpen).then(() => {
      commit('setIsMenuCollapsed', isOpen)
    })
  },
}
